import * as stylesPhone from './phone.module.css';
import * as stylesTabletDesktop from './tablet-desktop.module.css';
export function getDeviceStylesIdentity(deviceType) {
  if (deviceType === 'phone') {
    return deviceType;
  }
  return 'desktop';
}
export function getDeviceStyles(deviceType) {
  if (deviceType === 'phone') {
    return stylesPhone;
  }
  return stylesTabletDesktop;
}